import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('PaymentDA', PaymentDA);

    PaymentDA.$inject = ['Restangular', 'CONF', 'Payment', 'Beneficiairy', 'PaymentDetails'];

    /**
     * Accès à l'API concernant les paiements
     */

    /* @ngInject */
    function PaymentDA(Restangular, CONF, Payment, Beneficiairy, PaymentDetails) {
        var version = 'v1';
        var baseUrl = 'payment';

        var exports = {
            searchPayments: searchPayments,
            searchBeneficiaries: searchBeneficiaries,
            getPaymentDetails: getPaymentDetails,
        };

        return exports;

        ////////////////
        function searchPayments(searchValue) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl)
                .all('search')
                .post(searchValue)
                .then(pagePayments => {
                    return {
                        totalItems: pagePayments.totalElements,
                        payments: _.map(pagePayments.content, function (p) {
                            return new Payment(p);
                        }),
                    };
                });
        }

        function searchBeneficiaries(searchValue) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl)
                .all('beneficiaries')
                .all('search')
                .all('autocomplete')
                .post({ value: searchValue })
                .then(pageBeneficiaries => {
                    return _.map(pageBeneficiaries.content, b => new Beneficiairy(b));
                });
        }

        function getPaymentDetails(eid) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl)
                .all('session-ext')
                .all(eid)
                .one('details')
                .customGET()
                .then(data => new PaymentDetails(data));
        }
    }
})();
